var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_349125_6800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3413 5.41499C14.1862 12.2233 19.695 17.5908 26.6825 18.4142C19.695 19.2375 14.1862 24.605 13.3413 31.4133C12.4963 24.6208 6.9875 19.2533 0 18.4142C6.9875 17.5908 12.4963 12.2233 13.3413 5.41499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.205 2.53334C23.4975 4.86084 25.3825 6.69751 27.755 6.96667C25.3663 7.25167 23.4813 9.08834 23.205 11.4C22.9125 9.07251 21.0275 7.23584 18.655 6.96667C21.0438 6.68167 22.9288 4.84501 23.205 2.53334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8175 20.2508C32.2725 23.9242 35.2463 27.4075 39 27.8508C35.23 28.2942 32.2725 31.7933 31.8175 35.4508C31.3625 31.7775 28.3888 28.2942 24.635 27.8508C28.405 27.4075 31.3625 23.9083 31.8175 20.2508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_349125_6800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenAi);
export default __webpack_public_path__ + "static/media/GenAI.f75319e498c17dc10418147bfa8f1689.svg";
export { ForwardRef as ReactComponent };